/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'password-visibility',
  template: `
    <button mat-icon-button (click)="onClick()" type="button" tabindex="-1" class="password-visibility__button">
      <mat-icon class="scaled-icon" gta="password-visibility__mode">{{
        showPassword() ? 'visibility' : 'visibility_off'
      }}</mat-icon>
    </button>
  `,
  standalone: true,
  imports: [MatIconButton, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordVisibilityComponent {
  constructor() {
    effect(() => {
      this.for();
      this.hide();
    });
  }

  public for = input<HTMLInputElement>();

  public showPassword = signal<boolean>(false);

  onClick() {
    if (this.showPassword()) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.showPassword.set(true);
    this.for()?.setAttribute('type', 'text');
  }

  hide() {
    this.showPassword.set(false);
    this.for()?.setAttribute('type', 'password');
  }
}
